<script setup lang="ts">
import { useRouter } from 'vue-router'
import MissionStatusIndicator from 'Modules/components/feedback/MissionStatusIndicator.vue'
import NullFallbackTemplate from 'Common/components/templates/NullFallbackTemplate.vue'
import { formatDate } from 'Common/utils/formatDate'
import { JeteyeRoutes } from 'Modules/RouterSetup'
import type { RecentInspectionListEntryType } from 'Modules/types/pages/home/recentInspectionListEntryType'

interface PropTypes {
  data: Array<RecentInspectionListEntryType>
}

const props = defineProps<PropTypes>()
const router = useRouter()

const rowClick = (row: RecentInspectionListEntryType): void => {
  //FIXME Resolve typing
  const inspectionInstanceUuid = row?.inspectionInstanceUuid
  const aircraftUuid = row?.aircraftUuid

  router.push({
    name: JeteyeRoutes.SummaryReport,
    query: {
      aircraft: [aircraftUuid],
      inspectionInstance: [inspectionInstanceUuid],
    },
  })
}
</script>

<template>
  <div class="h-full">
    <el-table
      :data="props.data"
      :stripe="true"
      height="100%"
      :scrollbar-always-on="true"
      row-class-name="hover:cursor-pointer inspectionRow"
      @row-click="rowClick"
    >
      <el-table-column prop="type" label="Type" sortable />
      <el-table-column prop="label" label="Label" sortable />
      <el-table-column prop="status" label="Status" sortable>
        <template #default="scope">
          <MissionStatusIndicator :status="scope.row.status" />
        </template>
      </el-table-column>
      <el-table-column prop="started" label="Started" sortable>
        <template #default="scope">
          <NullFallbackTemplate :value="scope.row.startDate">
            <template #default>
              {{ formatDate(scope.row.startDate) }}
            </template>
            <template #fallback> - </template>
          </NullFallbackTemplate>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
